module.exports = __webpack_public_path__ + "static/img/logo.5a183aca.svg";